import styled from 'styled-components';

export const CategoryBlockWrapper = styled.div(
    props => `
      width:100%;
      display: flex;
      align-items: center;
      justify-content: center;
      @media only screen and (min-width: 320px) and (max-width: 1023px){
        align-items: center;
        justify-content: flex-start;
        overflow: auto;
        ::-webkit-scrollbar { 
          display: none; 
        } 
        margin-top: 3rem;
      }
    `
);

export const CategoryBlock = styled.ul(
    props => `
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin: ${props.theme.spacing.large.l40} 0;
      width:100%;
      align-items: center;
  
      li{
        display: flex;
        width: 27rem;
        border: 1px solid ${props.theme.colors.grey.lightd8};
        border-radius: ${props.theme.misc.borderRadius.base};
        flex-direction: column;
        margin: ${props.theme.spacing.base};
        padding: ${props.theme.spacing.base} ${props.theme.spacing.small.s5};
      }
      @media only screen and (min-width:320px) and (max-width: 767px){
        margin: ${props.theme.spacing.base} 0;
        width: 150rem;
        padding: 0 ${props.theme.spacing.large.l30} ${props.theme.spacing.large.l15};
        li{
          width: 28rem;
          margin: 0;
          padding: ${props.theme.spacing.base} ${props.theme.spacing.small.s5};
          margin-right: ${props.theme.spacing.base};
        }
      }
      @media only screen and (min-width:768px) and (max-width: 1024px){
        margin: ${props.theme.spacing.base} 0;
        width: 150rem;
        padding: 0 ${props.theme.spacing.large.l30} ${props.theme.spacing.large.l15};
        li{
          width: 28rem;
          margin: 0;
          padding: ${props.theme.spacing.base} ${props.theme.spacing.small.s5};
          margin-right: ${props.theme.spacing.base};
        }
      }
    `
);

export const StayBlockWrapper = styled.div(
    props => `
      padding: ${props.theme.spacing.small.s2};
      width:22rem;
      display: flex;
      flex-direction: column;

      @media(max-width:1023px){
        width: 15rem;
        margin-right:1rem;
      }
    `
);

export const StayImageBlock = styled.img(
    props => `
      width: 22rem;
      height: 23.5rem;
      border-radius: 2rem 2rem 0 0;

      @media(max-width:1023px){
        width: 15rem;
        height: 16rem;
      }
    `
);

export const TextWrapper = styled.p(
    props => `
      font-size: ${props.theme.font.large.font18};
      color: ${props.theme.colors.black.base};
      text-align: center;
      background-color: #fff;
      width:22rem;
      padding: 1.5rem;
      font-weight: ${props.theme.font.fontWeight.bold};
      border-radius: 0 0 0.8rem 0.8rem;
      @media only screen and (min-width:320px) and (max-width: 1023px){
        padding: 0.8rem;
        font-size: 1.4rem;
        width:15rem;
      }
    `
);